import React from "react";
import styled from "styled-components";
import lucius from '../../assets/img/Lucius-Portrait.png';
import nanalith from '../../assets/img/Nanalith-portrait.png';
import semor from '../../assets/img/Semor-Prortrait.png';
import { Title } from "../../components/MiniComponents";

const AboutUsRoot = styled.div`
    text-align: center;
    padding: 5em 8em;
    @media (max-width: 768px) {
        padding: 4em 0em;
    }
`;

const AboutUsList = styled.div`
    display:flex;
    flex-wrap: wrap;
    padding-top: 2em;
    @media (max-width: 768px) {
        padding: 0em;
    }
`;

const Author = styled.div`
    flex:1;
    margin:1em;
    @media (max-width: 768px) {
        margin: 1em;
        font-size: 0.8em;
    }
`

const Pseudo = styled.div`
    font-size: 2.5em;
`;

const Name = styled.div`
    font-size: 0.5em;
    color: grey;
    font-style: italic;
`;

const Portrait = styled.img`
    font-size: 4em;
    width: 6em;
    border: solid 2px black;
    border-radius: 1em;
    background: black;
    padding-top: 0.5em;
    height: 3.4em;
`;

const Text = styled.div`
    font-size: 1.5em;
    padding: 0 1em;
`;


const AboutUs = () => {
    return (
        <AboutUsRoot id="aboutUs">
            <Title>Notre équipe</Title>
            <AboutUsList>
                <Author>
                    <Pseudo>
                        Kieirra <Name>(Luc Marongiu)</Name>
                    </Pseudo>
                    <Portrait src={lucius} />
                    <Text style={{ color: "var(--main-color)" }}>
                        Lead designer
                    </Text>
                    <Text>
                        Messager de l'innomable et des fléaux apocalyptiques.
                    </Text>
                </Author>
                <Author>
                    <Pseudo>
                        Ana <Name>(Anaïs Marongiu)</Name>
                    </Pseudo>
                    <Portrait src={nanalith} />
                    <Text style={{ color: "var(--main-color)" }}>
                        Développeuse Front
                    </Text>
                    <Text>
                        Reine des succubes et fléau de l'humanité.
                    </Text>
                </Author>
                <Author>
                    <Pseudo>
                        Semarog <Name>(Serge Marongiu)</Name>
                    </Pseudo>
                    <Portrait src={semor} />
                    <Text style={{ color: "var(--main-color)" }}>
                        Graphiste
                    </Text>
                    <Text>
                        Abomination titanesque destructeur de monde.
                    </Text>
                </Author>
            </AboutUsList>
        </AboutUsRoot>
    )
};
export default AboutUs;


// WEBPACK FOOTER //
// ./src/pages/AboutUs/AboutUs.jsx